export const Marquee = ({ items, fast = false, className = "" }) => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-[#2C2623] py-4 ${className}`} data-testid="editorial-marquee">
      <div className={`flex whitespace-nowrap ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="mx-6 font-display text-sm sm:text-base font-bold uppercase tracking-[0.3em] text-[#7A7067]"
              >
                {item} <span className="text-[#E05A36] ml-6">/</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
